'use strict';

import React from 'react';
import RadioButtonList from '../Common/RadioButtonList.jsx';
import InlineMessage from '../Common/InlineMessage.jsx';

export default class PensionTypeBenefits extends React.Component {
    constructor(props) {
        super(props);
    }

    radioButtonListData() {
        let entries = this.props.entries,
            changeHandler = this.props.changeHandler,
            value = this.props.value;
        let render = null;
        if (entries) {
            if (entries.length === 1) {
                render = (<p>{entries[0].name}</p>);
            }
            else {
                render = (
                    <RadioButtonList id="pensionTypeBenefits"

                        data={entries}
                        handleChange={changeHandler}
                        model="selectedBenefitItem"
                        value={value} />
                );
            }
        }

        return render;
    }

    specificDisclaimerTextData() {
        return (this.props.disclaimerText)
            ? (<p dangerouslySetInnerHTML={{ __html: this.props.disclaimerText }} />)
            : null;
    }

    generalDisclaimerTextData() {
        return (this.props.generalDisclaimerText)
            ? (<p dangerouslySetInnerHTML={{ __html: this.props.generalDisclaimerText }} />)
            : null;
    }

    inlineMessageData() {
        var message = null;
        if (this.props.errorList && this.props.errorList.length > 0) {
            let errorMessage = this.props.errorList[0];
            message = (
                <InlineMessage id="pensionTypeInlineMessage"
                    isHidden={!errorMessage.message}
                    type={errorMessage.type}
                    message={errorMessage.message} />
            );
        }

        return message;
    }

    render() {
        return (
            <div className="form-section pension-type-benefits">
                {this.radioButtonListData()}
                {this.inlineMessageData()}
                {this.specificDisclaimerTextData()}
                {this.generalDisclaimerTextData()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/PensionType/PensionTypeBenefits.jsx